export const APP_MODE = "dev";
export const APP_SERVER_URL = "https://api.stage-winpot.mx/";
export const APP_WINPOT_CASINO = "https://stage-winpot.mx/";